export const DEFAULT_DEV_ORIGIN = "http://localhost:3000";
export const ALLOWED_ORIGIN_HOSTS: string[] = ["*.vercel.app"];
